<template>
  <div class="col-xxl-3 col-md-6 col-12 ms-xxl-3">
    <div class="row">
      <div class="col-xl-12">
        <div class="card account-card">
          <div class="card-body pt-0">
            <div class="account-header d-flex justify-content-between">
              <div class="account">Your account</div>
              <div class="account-icon">
                <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_749_16885)">
                    <path d="M4.448 14.2138V14.2138C4.448 12.6887 5.68432 11.4524 7.2094 11.4524H21.0216H31.4664H37.6824C39.2075 11.4524 40.4438 12.6887 40.4438 14.2138V14.2138V16.7163" stroke="#051C2C" stroke-width="2.82353"/>
                    <path d="M30.3171 5.06613L11.7278 16.1018L36.9137 16.1709L30.3171 5.06613Z" fill="#00C962"/>
                    <path d="M45.7957 25.6049V20.1684C45.7957 18.262 44.2503 16.7166 42.344 16.7166H6.95052C5.56841 16.7166 4.448 15.5962 4.448 14.2141V14.2141V43.2088C4.448 45.1152 5.9934 46.6606 7.89975 46.6606H42.344C44.2503 46.6606 45.7957 45.1152 45.7957 43.2088V37.7723" stroke="#051C2C" stroke-width="2.82353"/>
                    <mask id="path-4-inside-1_749_16885" fill="white">
                      <path d="M31.3801 31.6885C31.3801 28.3285 34.1039 25.6047 37.4638 25.6047H46.4868C47.44 25.6047 48.2127 26.3774 48.2127 27.3306V36.0463C48.2127 36.9995 47.44 37.7722 46.4868 37.7722H37.4638C34.1039 37.7722 31.3801 35.0484 31.3801 31.6885Z"/>
                    </mask>
                    <path d="M31.3801 31.6885C31.3801 28.3285 34.1039 25.6047 37.4638 25.6047H46.4868C47.44 25.6047 48.2127 26.3774 48.2127 27.3306V36.0463C48.2127 36.9995 47.44 37.7722 46.4868 37.7722H37.4638C34.1039 37.7722 31.3801 35.0484 31.3801 31.6885Z" stroke="#051C2C" stroke-width="5.64706" mask="url(#path-4-inside-1_749_16885)"/>
                    <circle cx="37.7242" cy="31.6879" r="1.41176" fill="#051C2C" stroke="#051C2C" stroke-width="0.54193"/>
                  </g>
                  <defs>
                    <clipPath id="clip0_749_16885">
                      <rect width="48" height="48" fill="white" transform="translate(0 0.452881)"/>
                    </clipPath>
                  </defs>
                </svg>
              </div>
            </div>
            <div class="account-details">
              <div class="account-balance">Account balance</div>
              <div class="value">{{ formatCurrency(computedDriverInfo.account_balance) }}</div>
              <p class="subtext">Money in your account pending withdrawal</p>
            </div>
            <hr />
            <div class="account-details">
              <div class="payment-method">Payment method</div>
              <div :class="computedDriverInfo.payment_method === 'Cash' ? 'badge-cash' : 'badge-bank'">{{ computedDriverInfo.payment_method }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useDriverStore } from '@/store/driver/driver';  // 確保這是你的正確路徑

// 使用 Pinia store
const driverStore = useDriverStore();

// 使用 computed 來監聽 driverInfo 的變化
const computedDriverInfo = computed(() => driverStore.driverInfo);

const formatCurrency = (value) => {
    const absValue = Math.abs(value); // 取得絕對值並固定為兩位小數
    return value < 0 ? `-$${absValue}` : `$${absValue}`;
};
</script>

<style scoped>
.account-card {
  border-radius: 10px;
  padding: 20px;
  text-align: left;
  width: 445px;
  height: 445px;
}

.account-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.account{
  font-family: Euclid Square;
  font-size: 24px;
  font-weight: 500;
  line-height: 30.43px;
  text-align: left;
}

.account-header h4 {
  font-size: 20px;
  font-weight: bold;
}

.account-balance{
  font-family: Mulish;
  font-size: 18px;
  font-weight: 400;
  line-height: 22.59px;
  text-align: left;
}

.account-details {
  margin-top: 10px;
}

.account-details .value {
  font-family: Euclid Square;
  font-size: 42px;
  font-weight: 600;
  line-height: 53.26px;
  text-align: left;
}

.account-details .subtext {
  font-family: Mulish;
  font-size: 15px;
  font-weight: 400;
  line-height: 18.83px;
  text-align: left;
  color: #666;
  margin-top: 20px;
}

.account-icon {
  text-align: right;
}

.payment-method{
  font-family: Mulish;
  font-size: 18px;
  font-weight: 400;
  line-height: 22.59px;
  text-align: left;
}

hr {
  margin: 40px 0;
  border-top: 1px solid rgba(153, 166, 180, 1);
  width: 365px;
  height: 0px;
  gap: 0px;
  opacity: 0px;
}

.badge-cash {
  width: 70px;
  color: black;
  padding: 5px 10px;
  border-radius: 5px;
  font-family: Euclid Square;
  font-size: 18px;
  font-weight: 700;
  line-height: 22.82px;
  font-weight: bold;
  border: 2px solid #00C962;
  margin-top: 10px;
  margin-bottom: 40px;
}




.badge-bank {
  width: 149px;
  color: black;
  padding: 5px 10px;
  border-radius: 5px;
  font-family: Euclid Square;
  font-size: 18px;
  font-weight: 700;
  line-height: 22.82px;
  font-weight: bold;
  border: 2px solid #00C962;
  margin-top: 10px;
  margin-bottom: 40px;
}
</style>
